'use strict';

var GridToolbarRomSummaryTopSpillController = function GridToolbarRomSummaryTopSpillController() {};
GridToolbarRomSummaryTopSpillController.$inject = [];
module.exports = GridToolbarRomSummaryTopSpillController;